import { artifactsClient } from "@artifacts/artifactsClient";
import { faPlay } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, FieldError } from "@scribenote/brian-design-system";
import { useState } from "react";

/** The presigned URL lasts about an hour, so every press fetches a fresh one. */
export const RecordingPlayer = ({ artifactId }: { artifactId: string }) => {
  const [source, setSource] = useState<string | null>(null);
  const [fetching, setFetching] = useState(false);
  const [failed, setFailed] = useState(false);

  const open = async () => {
    setFetching(true);
    setFailed(false);
    setSource(null);
    try {
      setSource(await artifactsClient.getDownloadUrl(artifactId));
    } catch {
      setFailed(true);
    } finally {
      setFetching(false);
    }
  };

  return (
    <div className="-mx-1 flex flex-col gap-2">
      <div className="flex flex-wrap items-center gap-2 px-1">
        <Button
          variant="outline"
          size="sm"
          busy={fetching}
          data-testid="phone-call-replay"
          onClick={() => void open()}
        >
          <FontAwesomeIcon icon={faPlay} aria-hidden="true" />
          {source ? "Reload recording" : "Play recording"}
        </Button>
      </div>
      {/* `data-dd-privacy="hidden"`: replay's `mask` doesn't censor `src` on
          media elements, so the hour-valid link to a recorded call would land
          in snapshots. `onError`: with `preload="none"` the URL can expire
          after it is handed over, so it first fails on play. */}
      {source && (
        <audio
          controls
          preload="none"
          src={source}
          data-dd-privacy="hidden"
          onError={() => {
            setSource(null);
            setFailed(true);
          }}
          className="w-full px-1"
          data-testid="phone-call-audio"
        />
      )}
      <FieldError className="px-1">
        {failed && "That recording wouldn't load. Try again in a moment."}
      </FieldError>
    </div>
  );
};
